import React from 'react';

import {
  Action,
  Actions,
  FileDownloadIcon,
  ActionBar,
} from '@gogame/components';
import { FullScreenToggler } from '@gogame/data-grid';
import { useChildComponent } from '@gogame/hooks-ts';
import {
  SearchField,
  useScreenGo,
  useScreenState,
  useScreenTitle,
} from '@gogame/screens';

import { PERMISSION_ACTION_MANAGE_CONVERSIONS } from 'scenes/Integrations/constants';
import { useIsAllowed } from '@gogame/permissions';
import { useExportIntegrations } from '../../data';
import {
  IntegrationConversionFormCreate,
  IntegrationPostbackFormCreate,
} from '../IntegrationForm';
import { IntegrationSelectPartner } from '../IntegrationForm/IntegrationConversionForm/IntegrationSelectPartner';

export default function IntegrationsToolbar() {
  const [childComponent, openChildComponent] = useChildComponent();
  const go = useScreenGo();
  const [screenTitle] = useScreenTitle();
  const screenState = useScreenState();
  const isAllowed = useIsAllowed();

  const [exportIntegrations] = useExportIntegrations();

  const handleExport = async () => {
    const { filters, tableSettings, searchQuery } = screenState;

    const params = {
      filters,
      tableSettings,
      searchQuery,
    };

    await exportIntegrations(params);
  };

  const handleCreatePostback = () => {
    openChildComponent(IntegrationPostbackFormCreate, {
      onSubmit: ({ typeId, id }) => {
        go(`${typeId}/${id}`);
      },
    });
  };

  const handleCreateConversion = () => {
    openChildComponent(IntegrationSelectPartner, {
      onChange: (data) => {
        openChildComponent(IntegrationConversionFormCreate, {
          providerType: data,
          onSubmit: ({ typeId, id }) => {
            go(`${typeId}/${id}`);
          },
        });
      },
    });
  };

  return (
    <>
      <ActionBar
        title={screenTitle}
        search={<SearchField tooltip={'Search by event'} />}
        secondaryActions={
          <Actions>
            <Action
              icon={<FileDownloadIcon />}
              onClick={handleExport}
              label={'Export'}
            />
            <Action component={FullScreenToggler} />
          </Actions>
        }
        primaryActions={
          <Actions>
            {isAllowed(PERMISSION_ACTION_MANAGE_CONVERSIONS) ? (
              <Action
                border={true}
                button={true}
                add={true}
                iconContent={true}
                tooltip={'Add Integration'}
                variant={'outlined'}
              >
                <Action label={'Postback'} onClick={handleCreatePostback} />
                <Action label={'Conversion'} onClick={handleCreateConversion} />
              </Action>
            ) : (
              <Action
                border={true}
                button={true}
                add={true}
                iconContent={true}
                tooltip={'Add Postback'}
                variant={'outlined'}
                onClick={handleCreatePostback}
              />
            )}
          </Actions>
        }
      />
      {childComponent}
    </>
  );
}
